import { RootState } from '../reducers';

export const selectAuthToken = ({ authentication }: RootState) =>
  authentication.token;

export const selectIsAuthenticated = ({ authentication }: RootState) =>
  Boolean(authentication.token);
